import styled from 'styled-components'

export const Header = styled.div`
    background-color:#272727a9;
    height:75px;
    width:100%;
    display: flex;
    align-items: center;
    font-size:1em;
    justify-content: space-between;
    padding-right:4%;
    padding-left:4%;
    *{
        list-style: none;
    }
`;